import React, { useState } from "react";
import PropTypes from "prop-types";

import {
  CrmAccessDisclaimer,
  RedtailSection,
  WealthboxSection,
} from "scenes/Onboarding/components/CrmIntegrationStep/components";

import { useConnectionType } from "../../hooks";
import { DisclaimerMessage } from "./components";

const CrmSectionMap = {
  Redtail: RedtailSection,
  Wealthbox: WealthboxSection,
};

function ConnectCRMModalBody({ crm, onDone }) {
  const [isAcknowledged, setAcknowledge] = useState(true);
  const { isCrmReset } = useConnectionType();

  if (crm in CrmSectionMap) {
    const CrmSection = CrmSectionMap[crm];

    return (
      <div
        style={{ display: "flex", flexDirection: "column" }}
        data-test="connect-crm-modal-body"
      >
        <DisclaimerMessage crm={crm} onAcknowledge={setAcknowledge} />

        <div style={{ width: "50%", alignSelf: "center", marginTop: "14px" }}>
          <CrmSection onDone={onDone} disabled={!isAcknowledged}>
            {!isCrmReset && <CrmAccessDisclaimer crm={crm} />}
          </CrmSection>
        </div>
      </div>
    );
  }

  return (
    <div data-test="connect-crm-modal-body">
      <p>
        We are working to integrate Hubly with {crm}. We appreciate your
        interest!
      </p>

      <p>Once it&apos;s ready, we will let you know.</p>

      <p>Thank you for your patience and enthusiasm.</p>
    </div>
  );
}

ConnectCRMModalBody.propTypes = {
  crm: PropTypes.string.isRequired,
  onDone: PropTypes.func.isRequired,
};

export default ConnectCRMModalBody;
